import { useState, useEffect } from "react";
import { onAuthStateChanged, signInWithPopup } from "firebase/auth";
import { auth, entraProvider } from "./core/utils/firebase";
import AuthScreen from "./components/AuthScreen";

export default function AuthLoader({ children }) {
  const [user, setUser] = useState(undefined);
  const [error, setError] = useState(null);

  useEffect(() => {
    return onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) setError(null);
      setUser(currentUser);
    });
  }, []);

  const login = async () => {
    setError(null);
    try {
      await signInWithPopup(auth, entraProvider);
    } catch (e) {
      if (e?.code === "auth/popup-closed-by-user" || e?.code === "auth/cancelled-popup-request") {
        return;
      }
      setError(e?.message || "No se pudo iniciar sesión");
    }
  };

  if (user) return children;

  return (
    <AuthScreen
      waiting={user === undefined}
      errorMessage={error}
      onSignIn={login}
    />
  );
}
